<template>
  <v-dialog v-model="show" max-width="800px" v-if="loaded">
    <v-card>
      <v-card-title>Prozessmodell freigeben
        <v-spacer/>
        <IconTooltipButtonBottom
          icon="mdi-close"
          tooltip="Schließen"
          id="default"
          @click="close()"
        />
      </v-card-title>
      <div>
        <v-card-text class="px-12">
            <h4>Für Nutzer der Motiverse-Plattform freigeben</h4>
            <v-select
                v-model="selectedUser"
                :items="users"
                item-text="fullName"
                item-value="userId"
              ></v-select>
        </v-card-text>
          <v-card-actions class="px-12">
            <v-spacer/>
            <v-btn elevation="0" @click.stop="shareProcessModel()" color="primary">Freigeben</v-btn>
<!--            <v-btn text @click.stop="show=false">Abbrechen</v-btn>-->
          </v-card-actions>
        <v-divider></v-divider>
        <v-card-text class="px-12 pb-10">
            <h4>Prozessmodell per Link freigeben</h4>
             <v-text-field
                v-if="linkCreated"
                label="Link zur Freigabe"
                readonly
                :value="shareLink"
                append-icon="mdi-content-copy"
                @click:append="copyToClipboard()"
              ></v-text-field>
              <v-btn text v-if="!linkCreated" color="primary" @click="generateShareLink()">Freigabelink generieren</v-btn>
          <span class="font-s text-gray mt-0">Jeder der über diesen Link verfügt kann auf das Prozessmodell
            zugreifen</span>
          <v-card v-if="copied" flat style="background: var(--green-color_s)" class="px-6 py-4 mt-6 d-flex">
            <v-icon color="tr_green" class="mr-2">mdi-check-circle</v-icon><h5>Kopiert!</h5>
          </v-card>
        </v-card-text>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import IconTooltipButtonBottom from "@/components/common/IconTooltipButtonBottom.vue";
import processShareService from "./Share/process-share-service";
import processModelingService from "./process-modeling-service";
export default {
  components: {
    IconTooltipButtonBottom
  },
  props: {
    value: Boolean,
    uuid: {
      required: true,
      type: String
    },
    copied: false,
  },
  computed: {
    show: {
      cache: false,
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
  },
  data() {
    return {
      users: [],
      selectedUser: null,
      linkCreated: false,
      shareLink: null,
      loaded: false
    };
  },
  watch: {
    show: function(show) {
      if (show) {
        this.users = [];
        processModelingService.retrieveAllUsers().then(allUsers => {
          processModelingService.retrieveSharedUsers(this.uuid).then((sharedUsers) => {
            allUsers.data.forEach( user => {
              if (!(sharedUsers.data.find(sharedUser => sharedUser.userId === user.userId))) {
                user.fullName = user.firstName+' '+user.lastName;
                this.users.push(user);
              }
            })
            processShareService.getShareLinkIfExists(this.uuid).then((res => {
              if(res.data != null && res.data != ''){
                this.shareLink = location.origin+'/motiverse/#'+this.$route.path + res.data;
                this.linkCreated = true;
              }
              this.loaded = true;
            }))
          });
        });
      }
    }
  },
  methods: {
    generateShareLink(){
      processShareService.generateShareToken(this.uuid).then((res) => {
        this.shareLink = location.origin+'/motiverse/#'+this.$route.path + res.data;
        this.linkCreated = true;
      })
    },
    copyToClipboard(){
      navigator.clipboard.writeText(this.shareLink);
      this.copied = true;
    },
    shareProcessModel() {
      if (!this.selectedUser) return;
      processModelingService.shareTask(this.uuid, this.selectedUser).then(() => {
        this.show = false;
        this.selectedUser = null;
      });
    },
    close() {
      this.copied = false;
      this.show = false;
    }
  }
};
</script>
<style>
:deep .v-text-field__details {
  display: none !important;
}
</style>